import { __assign } from 'tslib';
import React__default from 'react';
import TreeField from '../TreeField/index.js';

var FieldThesaurus = function (props) {
    // TODO Logic from FieldThesaurusContainer should be moved here
    return React__default.createElement(TreeField, __assign({ testId: "FieldThesaurus" }, props));
};

export { FieldThesaurus as default };
//# sourceMappingURL=index.js.map
